import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Instance from 'highcharts'
import SankeyAddOn from 'highcharts/highcharts-more'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './SankeyChart.styles'

SankeyAddOn(Instance)

/**
 * The SankeyChart's component.
 */
const SankeyChart = props => {
  const { data, id } = props
  const theme = useTheme()
  const colors = [
    theme.palette.brand.primary,
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue,
    theme.palette.charts.toryBlue,
    theme.palette.charts.jacksonsPurple,
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue,
    theme.palette.charts.toryBlue,
    theme.palette.charts.jacksonsPurple,
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue,
    theme.palette.charts.toryBlue,
    theme.palette.charts.jacksonsPurple,
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue
  ]
  const enhancedData = data.map((datum, index) => ({ ...datum, color: colors[index] }))
  const options = {
    accessibility: { enabled: false },
    chart: {
      height: 600
    },
    plotOptions: {
      series: {
        linkOpacity: 0.9,
        states: { inactive: { linkOpacity: 0.6 } }
      }
    },
    series: [
      {
        colors,
        data: enhancedData,
        dataLabels: {
          color: theme.palette.brand.white,
          style: { fontSize: '12px', fontWeight: 'light', textOutline: 'none' }
        },
        minLinkWidth: 30,
        name: '',
        type: 'sankey'
      }
    ],
    title: { text: '' },
    tooltip: { enabled: false }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
      </Root>
    </>
  )
}

SankeyChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string,
      weight: PropTypes.number
    })
  ).isRequired,
  id: PropTypes.string.isRequired
}

export default SankeyChart
